import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getAppProviders } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { ENVIRONMENT } from '@env/environment';
import { AppInjector } from '@shared/services/app-injector.service';

if (browserSupported()) {
  if (ENVIRONMENT.production) {
    enableProdMode();
  }

  // Note: enableProfiling() removed - it causes assertion errors with complex change detection
  // Only re-enable for specific performance debugging sessions
  bootstrapApplication(AppComponent, {
    providers: getAppProviders(ENVIRONMENT)
  })
    .then(appRef => (AppInjector.injector = appRef.injector))
    .catch(err => console.error(err));

  addDayjsPlugins();
} else {
  window.location.replace('/browser-not-supported.html');
}

function browserSupported(): boolean {
  // check if browser is Opera (before Chrome/Edge check as Opera includes chrome related user agent data)

  if (
    (navigator.userAgent.toLowerCase().indexOf('opera') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('opr') !== -1) &&
    !!(window as any).opr
  ) {
    return false;
  }

  // check if browser is not Chrome or Edge

  if (
    navigator.userAgent.toLowerCase().indexOf('edg') === -1 &&
    navigator.userAgent.toLowerCase().indexOf('chrome') === -1 &&
    // this is needed for chrome on iOS

    navigator.userAgent.toLowerCase().indexOf('crios') === -1
  ) {
    return false;
  }

  return true;
}

function addDayjsPlugins() {
  dayjs.extend(relativeTime);
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
}
